<template>
  <v-container fluid>
    <v-flex xs12>
      <ChangePassword />
    </v-flex>
  </v-container>
</template>

<script>
// import { mapActions } from 'vuex';
import ChangePassword from './../components/Profile/ChangePassword.vue';

export default {
  name: 'set-password',
  components: {
    ChangePassword,
  },
};
</script>
